var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMounted)?_c('div',{staticClass:"pages-preview-container"},[_c('ElmPreview',{attrs:{"ports":_vm.setupPorts,"flags":_vm.flags}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }